// extracted by mini-css-extract-plugin
module.exports = {"root":"CosmeticCreateEdit_root__1f9fi"};